export default __webpack_public_path__ + "static/media/ChristineJones-2.3b634beb.jpg";